<template>

    <div class="container">

        <div class="searchBox">

            <el-form
                    ref="search_data"
                    :model="search_data"
                    label-width="150px"
                    size="medium"
            >

                <div>
                    <el-form-item label-width="150px">
                        <el-switch
                                v-model="search_data.type"
                                active-text="订单数量"
                                inactive-text="订单金额"
                                active-value="1"
                                inactive-value="0"
                        >
                        </el-switch>

                    </el-form-item>
                </div>

                <div>
                    <el-form-item label-width="150px">

                        <el-button
                                type="primary"
                                icon="el-icon-search"
                                @click="searchdriverOrderCountLists"
                        >搜索
                        </el-button>
                        <el-button
                                icon="el-icon-refresh-right"
                                @click="refresh"
                        >刷新
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>

        </div>
        <div class="searchInfo">

            <div>
                <!-- 表格 -->
                <el-table
                        :data="tableData"
                        style="width: 100%"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                >
                    <el-table-column width="50">
                    </el-table-column>

                    <el-table-column
                            prop="name"
                            label="司机名称"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            label="电话"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="count_num"
                            label="单数"
                    >
                        <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{scope.row.count_num}}单
              </span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="sum_num"
                            label="金额"
                    >
                        <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{scope.row.sum_num}}元
              </span>
                        </template>
                    </el-table-column>

                </el-table>

            </div>
            <!-- 分页组件 -->
            <div class="pagination">
                <pages
                        :search_data="search_data"
                        :result_data="result_data"
                        @pages_function="pages_function"
                ></pages>
            </div>

        </div>

    </div>

</template>

<script>
    var _this;

    export default {
        data() {
            return {
                // 下拉搜索城市
                value_city_code: '',
                options_city_code: [],
                city_options_data: {
                    page: 1,
                    limit: 50,
                    name: ''
                },
                company_name: '',

                search_time: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    type: '0'
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;

            _this.driverOrderCountLists();
        },

        methods: {
            searchdriverOrderCountLists() {
                _this.search_data.page = 1;
                _this.driverOrderCountLists();
            },
            // 搜索司机日志列表
            driverOrderCountLists() {
                _this
                    .$post(
                        '/statistics/driverOrderCountLists',
                        _this.search_data,
                        _this.search_rules
                    )
                    .then((res) => {
                        console.log(res.data);
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {
                    });
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverOrderCountLists();
            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
</style>